import React, { useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { LanguageContext } from '../components/LanguageContext';
import catalogData from '../locales/catalogData.json';
import '../styles/CatalogBook.css';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function SearchResults() {
    const { language } = useContext(LanguageContext);
    const query = useQuery();
    const q = (query.get('q') || '').toLowerCase();

    const items = catalogData[language] || catalogData['ru'];
    // Ищем по model и shortDescription, а не по полному description
    const results = items.filter(item =>
        item.model.toLowerCase().includes(q) ||
        item.shortDescription.toLowerCase().includes(q)
    );

    return (
        <section className="catalog-container">
            <h2 className="catalog-title">
                {language === 'kg'
                    ? `Жыйынтыктар: «${q}»`
                    : `Результаты поиска: «${q}»`}
            </h2>

            {results.length > 0 ? (
                <div className="catalog-grid">
                    {results.map(item => (
                        <div key={item.id} className="catalog-card">
                            <div className="catalog-image-wrapper">
                                <img
                                    src={item.image}
                                    alt={item.model}
                                    className="catalog-image"
                                />
                            </div>
                            <h3>{item.model}</h3>
                            <p>{item.shortDescription}</p>
                            <Link
                                to={`/catalog/${encodeURIComponent(item.id)}`}
                                className="btn-details"
                            >
                                {language === 'kg' ? 'Толугураак' : 'Подробнее'}
                            </Link>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="no-results">
                    {language === 'kg'
                        ? `«${q}» боюнча эч нерсе табылган жок.`
                        : `По запросу «${q}» ничего не найдено.`}
                </p>
            )}
        </section>
    );
}
